<div class="seguridad-header">
  <div class="seguridad-header__accent"></div>
  <div class="container seguridad-header__inner">
    <span class="material-icons seguridad-header__icon">file_copy</span>
    <div>
      <h1 class="seguridad-header__title">Inscripciones</h1>
      <p class="seguridad-header__subtitle">Listado de inscripciones del sistema</p>
    </div>
  </div>
</div>

<div class="profile-area pb-70">
  <div class="container">
    <div class="profile-courses-quizzes">
      <div class="d-flex justify-content-between align-items-center">
        <h3>Aquí encontrará el estado de las <strong>inscripciones</strong> realizadas</h3>
      </div>

      <mat-card class="search-card">
        <div class="container mt-4" style="display: flex; align-items: center;">
            <mat-form-field class="mr-2">
                <mat-label>Desde</mat-label>
                <input matInput [matDatepicker]="pickerDesde" placeholder="Seleccione una fecha" [(ngModel)]="fechaDesde">
                <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
                <mat-datepicker #pickerDesde></mat-datepicker>
            </mat-form-field>

            <div style="width: 20px;"></div>

            <mat-form-field class="mr-2">
                <mat-label>Hasta</mat-label>
                <input matInput [matDatepicker]="pickerHasta" placeholder="Seleccione una fecha" [(ngModel)]="fechaHasta">
                <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
                <mat-datepicker #pickerHasta></mat-datepicker>
            </mat-form-field>

            <div>
                <button mat-raised-button color="warn" class="button-margin" (click)="buscarPorFechas()">Buscar</button>
                <button mat-raised-button color="warn" 
                        (click)="exportarSolicitudes()" 
                        [disabled]="!fechaDesde || !fechaHasta || loading">
                    Exportar a Excel
                </button>
            </div>
        </div>
      </mat-card>

      <hr style="margin-top: 20px; margin-bottom: 20px;">

      <!-- Indicador de carga principal (mientras se obtienen/ filtran los datos) -->
      <div *ngIf="!flagLoaded; else contenidoListado" class="d-flex flex-column justify-content-center align-items-center" style="min-height: 300px;">
        <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
        <div class="loading-message mt-2">Procesando, por favor espere...</div>
      </div>

      <!-- Contenido real: pestañas, filtros y tabla -->
      <ng-template #contenidoListado>
        <div style="overflow-x: auto; width: 100%;">
          <mat-form-field appearance="fill">
            <mat-label>Selecciona un estado</mat-label>
            <mat-select [(ngModel)]="selectedEstados" [disabled]="!solicitudes"
              (selectionChange)="cargarSolicitudesPorEstado($event.value)" name="estados" multiple>
              <mat-option *ngFor="let estado of estadosInscripcion" [value]="estado.number">
                {{estado.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div>
            <mat-form-field>
              <mat-label>Filtrar</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Inscripción...">
            </mat-form-field>

            <div class="mat-elevation-z8">
              <table mat-table [dataSource]="dataSource">

                <!-- Columna: Nro. Solicitud -->
                <ng-container matColumnDef="nro_solicitud">
                  <th mat-header-cell *matHeaderCellDef> Nro. Solicitud </th>
                  <td mat-cell *matCellDef="let element" class="column-cell"> {{element._nro}} </td>
                </ng-container>

                <!-- Columna: Fecha Solicitud -->
                <ng-container matColumnDef="fechaEstado">
                  <th mat-header-cell *matHeaderCellDef> Fecha Solicitud </th>
                  <td mat-cell *matCellDef="let element" class="column-cell"> {{element.createdAt | date:"dd/MM/yy"}}
                  </td>
                </ng-container>

                <!-- Columna: Trámite -->
                <ng-container matColumnDef="trámite">
                  <th mat-header-cell *matHeaderCellDef> Trámite </th>
                  <td mat-cell *matCellDef="let element" class="column-cell"> {{element.actividad_nombre}} </td>
                </ng-container>

                <!-- Columna: Tipo -->
                <ng-container matColumnDef="tipo">
                  <th mat-header-cell *matHeaderCellDef> Tipo </th>
                  <td mat-cell *matCellDef="let element" class="column-cell">
                    <span *ngIf="getTipoAfiliacion(element)"
                          class="tipo-chip"
                          [ngClass]="element?.inscripcion?.contenido?.tipoAfiliacion === 'mutual' ? 'tipo-chip--mutual' : 'tipo-chip--sindicato'">
                      {{ getTipoAfiliacion(element) }}
                    </span>
                  </td>
                </ng-container>

                <!-- Columna: Identificación -->
                <ng-container matColumnDef="identificacion">
                  <th mat-header-cell *matHeaderCellDef> Identificación </th>
                  <td mat-cell *matCellDef="let element" class="column-cell"> {{element.usuario_identificacion |
                    nombreExiste}} </td>
                </ng-container>

                <!-- Columna: Estado -->
                <ng-container matColumnDef="estado">
                  <th mat-header-cell *matHeaderCellDef> Estado </th>
                  <td mat-cell *matCellDef="let element" class="column-cell"
                    [ngStyle]="{'color': getColor(element.lastState_numberState)}">
                    {{ getStateName(element.lastState_numberState) }}
                  </td>
                </ng-container>

                <!-- Columna: Progreso -->
                <ng-container matColumnDef="progreso">
                    <th mat-header-cell *matHeaderCellDef> Progreso </th>
                    <td mat-cell *matCellDef="let element" style="min-width: 120px;" class="column-cell">
                        <div class="progress">
                            <div class="progress-bar-background"></div>
                            <div class="progress-bar" 
                                [ngClass]="{
                                    'bg-secondary': element.lastState_numberState === 6,
                                    'bg-danger': element.lastState_numberState === 5 || 
                                                (element.lastState_numberState >= 0 && element.lastState_numberState <= 4 && ((element.lastState_numberState + 1)/5 * 100) <= 20) ||
                                                element.lastState_numberState === 14,
                                    'bg-warning': (element.lastState_numberState >= 0 && element.lastState_numberState <= 4 && ((element.lastState_numberState + 1)/5 * 100) > 20 && ((element.lastState_numberState + 1)/5 * 100) <= 60) ||
                                                  element.lastState_numberState === 15,
                                    'bg-info': (element.lastState_numberState >= 0 && element.lastState_numberState <= 4 && ((element.lastState_numberState + 1)/5 * 100) > 60 && ((element.lastState_numberState + 1)/5 * 100) <= 80),
                                    'bg-success': (element.lastState_numberState >= 0 && element.lastState_numberState <= 4 && ((element.lastState_numberState + 1)/5 * 100) > 80) ||
                                                  element.lastState_numberState === 16
                                }"
                                [style.width]="
                                    (element.lastState_numberState === 5 || element.lastState_numberState === 6 ? 100 : 
                                    element.lastState_numberState === 14 ? 33 :
                                    element.lastState_numberState === 15 ? 66 :
                                    element.lastState_numberState === 16 ? 100 :
                                    ((element.lastState_numberState + 1)/5 * 100)) + '%'">
                                
                                <span>
                                    {{ 
                                        element.lastState_numberState === 5 ? 'ANULADO' : 
                                        element.lastState_numberState === 6 ? 'EN ESPERA' : 
                                        element.lastState_numberState === 14 ? '33%' :
                                        element.lastState_numberState === 15 ? '66%' :
                                        element.lastState_numberState === 16 ? '100%' :
                                        ((element.lastState_numberState + 1)/5 * 100 | number:'1.0-0') + '%' 
                                    }}
                                </span>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- Columna: Acciones -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> Acciones </th>
                  <td mat-cell *matCellDef="let element">
                    <div style="display: inline-flex;">
                      <button (click)="verSolicitud(element)" mat-raised-button class="btn btn-success"
                        style="margin-right: 5px;">
                        <i class="fas" [ngClass]="{'fa-eye': element.leido, 'fa-eye-slash': !element.leido}"
                          [ngStyle]="{'color': !element.leido ? 'blue' : ''}"></i>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <!-- Definición de filas -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Fila que se muestra cuando no hay datos coincidentes -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No hay datos que coincidan con el filtro</td>
                </tr>

              </table>

              <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"
                aria-label="Selecciona página de solicitudes"></mat-paginator>

            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- Loading Spinner para acciones individuales (exportar, ver solicitud) -->
<div *ngIf="loading" class="loading-overlay">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>